import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/jenkins_home/workspace/outstation.web_main/app/onehub/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/jenkins_home/workspace/outstation.web_main/app/onehub/summary/components/BookHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/jenkins_home/workspace/outstation.web_main/app/onehub/summary/components/HubLink.tsx");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/accordion/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/autocomplete/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/avatar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/breadcrumbs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/button/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/calendar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/card/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/checkbox/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/chip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/date-input/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/date-picker/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/dropdown/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ResizablePanel"] */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/framer-utils/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/image/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/input/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/link/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/listbox/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/modal/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/navbar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/pagination/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/popover/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/progress/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/radio/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/ripple/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/scroll-shadow/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/select/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/slider/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/snippet/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/switch/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/system/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/table/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/tabs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/tooltip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/@nextui-org/user/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/next/font/google/target.css?{\"path\":\"app/onehub/summary/[urlId]/quote/components/HeaderInfo.tsx\",\"import\":\"Tiro_Tamil\",\"arguments\":[{\"weight\":\"400\",\"subsets\":[\"tamil\"]}],\"variableName\":\"tiro\"}");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/next/font/google/target.css?{\"path\":\"app/onehub/summary/[urlId]/quote/components/QuoteList.tsx\",\"import\":\"Libre_Baskerville\",\"arguments\":[{\"weight\":\"400\",\"style\":\"italic\",\"subsets\":[\"latin\"]}],\"variableName\":\"libre\"}");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/next/font/google/target.css?{\"path\":\"app/onehub/summary/[urlId]/quote/components/QuoteList.tsx\",\"import\":\"Tiro_Tamil\",\"arguments\":[{\"weight\":\"400\",\"subsets\":[\"latin\"]}],\"variableName\":\"tiro\"}");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/outstation.web_main/node_modules/next/font/google/target.css?{\"path\":\"app/onehub/summary/[urlId]/quote/components/QuoteList.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"400\",\"600\"],\"subsets\":[\"latin\"]}],\"variableName\":\"poppins\"}");
